import React from "react";
import ActionButton from "./ActionButton";
import { URL } from "../../config";

const ActionButtons = ({ configureUrl, motorcycleName }) => {
  const isHimalayan750 = motorcycleName === "Himalayan 750";

  const handleBookTestRide = () => {
    const targetUrl = isHimalayan750
      ? URL.HIMALAYAN_750
      : URL.TEST_RIDE;
    if (
      window.webkit &&
      window.webkit.messageHandlers &&
      window.webkit.messageHandlers.openLinkInBrowser
    ) {
      window.webkit.messageHandlers.openLinkInBrowser.postMessage(targetUrl);
      console.info(
        "Opened CTA in browser via iOS bridge function"
      );
    } else if (
      window.Android &&
      typeof window.Android.openLinkInBrowser === "function"
    ) {
      window.Android.openLinkInBrowser(targetUrl);
      console.info(
        "Opened CTA in browser via Android bridge function"
      );
    } else {
      console.warn(
        "Bridge function not available, opening in a new tab as fallback"
      );
      window.open(targetUrl);
    }
  };

  const handleConfigureNow = () => {
    window.passURLtoMobile(6.02, configureUrl, "CONFIGURE_NOW");
  };

  return (
    <div className="flex flex-row justify-center gap-4 w-full max-w-md mx-auto px-4">
      {!isHimalayan750 && (
        <ActionButton onClick={handleConfigureNow}>
          CONFIGURE NOW
        </ActionButton>
      )}
      <ActionButton variant="highlighted" onClick={handleBookTestRide}>
        {isHimalayan750 ? "STAY UPDATED" : "BOOK A TEST RIDE"}
      </ActionButton>
    </div>
  );
};

export default ActionButtons;